import { InfiniteData } from "@tanstack/react-query";

export function upsertById<T extends { id: string | number }>(
  items: T[],
  next: T
): T[] {
  const idx = items.findIndex((i) => i.id === next.id);
  if (idx === -1) return [next, ...items];
  return items.map((i) => (i.id === next.id ? next : i));
}

export function replaceById<T extends { id: string | number }>(
  items: T[],
  next: T
): T[] {
  return items.map((i) => (i.id === next.id ? next : i));
}

export function removeById<T extends { id: string | number }>(
  items: T[],
  id: T["id"]
): T[] {
  return items.filter((i) => i.id !== id);
}

export function removeByIds<T extends { id: string | number }>(
  items: T[],
  ids: Array<T["id"]>
): T[] {
  const set = new Set(ids);
  return items.filter((i) => !set.has(i.id));
}

export function updateInfiniteData<TPage, TItem>(
  prev: InfiniteData<TPage>,
  mapPage: (page: TPage, pageIndex: number) => TPage,
  mapPageParam: (pageParam: unknown, pageIndex: number) => unknown = (p) => p
): InfiniteData<TPage> {
  return {
    pageParams: prev.pageParams.map(mapPageParam),
    pages: prev.pages.map(mapPage),
  };
}
